import { IsDefined, IsString, IsUUID } from 'class-validator';

export class LoginByTokenRequest {
    @IsDefined()
    @IsString()
    @IsUUID()
    public token: string;

    constructor(data?: Partial<LoginByTokenRequest>) {
        this.token = data?.token;
    }
}
